import { AfterViewChecked, AfterViewInit, ChangeDetectorRef, Component, Input, OnInit, ViewChild } from '@angular/core';
import { FormlyFieldConfig } from '@ngx-formly/core';
import { ColDef } from 'ag-grid-community';
import { Observable } from 'rxjs';

import { BarcodeTypes } from '../../constants';
import { ScannerStockDetails } from '../../models';
import { AggFunc, BaseFormComponent, FormlyService, GridService, ModalService } from '../../../tms-shared';
import { ModalInfoService } from '../../../tms-shared/services/modal-info.service';

@Component({
  selector: 'app-base-view-stock',
  templateUrl: './base-view-stock.component.html',
  styleUrl: './base-view-stock.component.scss',
})
export class BaseViewStockComponent implements OnInit, AfterViewInit, AfterViewChecked {
  @ViewChild('viewStockForm') form: BaseFormComponent;
  @Input() header: string;
  @Input() extraFields = false;
  @Input() getStock: (location: string) => Observable<ScannerStockDetails[]>;

  model$: Observable<ScannerStockDetails[]>;
  fields: FormlyFieldConfig[];

  columnDefs: ColDef[] = [
    this.gridService.text('stockNo', $localize`Stock Number`, { aggFunc: AggFunc.count }),
    this.gridService.text('batchNo', $localize`Batch`),
    this.gridService.text('productKey', $localize`Product`),
    this.gridService.text('balance', $localize`Balance`, { aggFunc: AggFunc.sum }),
  ];

  constructor(
    private formlyService: FormlyService,
    private gridService: GridService,
    private modalService: ModalService,
    private modalInfoService: ModalInfoService,
    private changeDetector: ChangeDetectorRef,
  ) {}

  ngOnInit(): void {
    if (this.extraFields) {
      this.columnDefs.push(
        this.gridService.text('grade', $localize`Grade`),
        this.gridService.date('dateIntoStock', $localize`Date Into Stock`),
      );
    }
    this.getFields();
  }

  ngAfterViewInit(): void {
    this.focusField();
  }

  ngAfterViewChecked(): void {
    this.changeDetector.detectChanges();
  }

  private getFields() {
    this.fields = [
      this.formlyService.text('locationKey', $localize`Location`, undefined, {
        enter: () => this.getModel(),
        blur: () => this.getModel(),
        focus: () => this.clearLocation(),
        backspaceReset: true,
      }),
      this.formlyService.button($localize`Next Location`, () => this.clearLocation()),
    ];
  }

  private clearLocation() {
    this.form.updateModel({ locationKey: undefined });
    this.model$ = undefined;
    this.focusField();
  }

  private getModel() {
    const location = this.form.model.locationKey;
    const barcodeType = location.slice(0, 2);
    if (
      barcodeType !== BarcodeTypes.stockItem &&
      barcodeType !== BarcodeTypes.job &&
      barcodeType !== BarcodeTypes.machine &&
      barcodeType !== BarcodeTypes.piece &&
      barcodeType !== BarcodeTypes.operator &&
      barcodeType !== BarcodeTypes.warehouseAllocation
    ) {
      this.model$ = this.getStock(this.form.model.locationKey);
    } else {
      this.modalInfoService.infoSmall($localize`Location Stock`, $localize`Invalid Barcode Type`);
    }
  }

  private focusField() {
    this.formlyService.focusElement('locationKey');
  }
}
